<ws-modal-wrapper [headerLabel]="'Bill Cluster Tax Rate Details' + (title ? ' - ' + title : '')"
                  [hideFooter]="true"
                  [excludeModalStyling]="true"
                  [loading]="!firstEncounterTaxAuthority && loadingAll"
                  (cancel)="closeModal()">
    @if (!firstEncounterTaxAuthority) {
        <div class="tax-rate-setup">
            @if (!loadingAll && model) {
                <div class="row content-container">
                    @if (readOnly) {
                        <div class="top-actions">
                            <span style="font-weight:bold;">Tax Rate Area:</span>
                            <span>{{ model.name || '(none)' }}</span>
                        </div>
                    }
                    @if (!readOnly) {
                        <div class="top-actions">
                            <label>Tax Rate Area:</label>
                            <input
                                #taxRateAreaInput
                                name="taxRateArea"
                                type="text"
                                placeholder="Tax Rate Area..."
                                class="form-control"
                                autocomplete="off"
                                [ngModel]="model.name"
                                (blur)="onTaxRateAreaTextChange()"
                                [disabled]="loading || model.usingParentRates || isEarlierRevisionSelected"
                                [wsTypeahead]="availableTaxRateAreas"
                                [typeaheadOptionsLimit]="100"
                                typeaheadOptionField="name"
                                [typeaheadScrollable]="true"
                                [typeaheadMinLength]="0"
                                (typeaheadOnSelect)="onTaxRateAreaIdChange($event)"/>
                            <div class="clear-tax-rate-container">
                                @if (model.taxRateAreaId && !model.usingParentRates) {
                                    <button
                                        [disabled]="loading || isEarlierRevisionSelected"
                                        type="button"
                                        class="edit-control btn-sm ace-btn has-icon btn-primary btn-danger"
                                        (click)="clearSelectedTaxRateAreaId()"
                                    >
                                        <i class="fa fa-close"></i>
                                    </button>
                                }
                            </div>
                            <!-- <button type="button" class="ace-btn info-button btn-sm search" [disabled]="loading || model.usingParentRates">Search</button> -->
                        </div>
                    }
                    <hr/>
                    @if (showRevisionSelect) {
                        <div class="revision-select">
                            <label for="revisionSelect">Revision:</label>
                            <select
                                id="revisionSelect"
                                name="revision"
                                [(ngModel)]="selectedAnnualAssessmentId"
                                (ngModelChange)="onRevisionChange($event)"
                                [disabled]="loading"
                                class="form-select form-select-sm">
                                @for (revision of model.revisions; track revision.annualAssessmentId) {
                                    <option [ngValue]="revision.annualAssessmentId">{{ revision.label }}</option>
                                }
                            </select>
                        </div>
                    }
                    @if (hasNoTaxableValuesToMap) {
                        <div class="no-taxable-values">
                            This revision has no taxable values, so its Tax Authorities cannot be mapped.
                        </div>
                    }
                    <div class="table-container">
                        <table class="tax-rate-setup">
                            <tr>
                                <th>Code</th>
                                <th>Tax Authority</th>
                                <th>Category</th>
                                <th>Taxable Asmt Type</th>
                                <th class="right-align">Assessment</th>
                                <th class="right-align">Adjustment</th>
                                <th class="right-align">Taxable Asmt</th>
                                <th class="right-align" style="width:6em">Rate</th>
                                <th class="processing-action"></th>
                                <th class="right-align" style="width:10em">Annual Tax Amount</th>
                            </tr>
                            @for (group of currentTaxAuthorityGroups; track group; let i = $index) {
                                @if (groupByCategory && i !== 0) {
                                    <tr class="grouping-spacer">
                                        <td colspan="11"></td>
                                    </tr>
                                }
                                @for (taxAuthority of group.taxAuthorities; track taxAuthority) {
                                    <tr>
                                        <td>{{ taxAuthority.code }}</td>
                                        <td>{{ taxAuthority.name }}</td>
                                        <td>{{ taxAuthorityCategoryName(taxAuthority.taxAuthorityCategoryId) }}</td>
                                        <td>
                                            @if (isManualTaxableValueMode) {
                                                @if (!readOnly) {
                                                    <select
                                                        [ngModel]="taxAuthority.annualAssessmentTaxableValueId"
                                                        (ngModelChange)="onTaxableValueChange(taxAuthority, $event)"
                                                        [disabled]="loading"
                                                        class="form-select form-select-sm">
                                                        <option [ngValue]="null">-- Unmapped --</option>
                                                        @for (
                                                            option of model.availableTaxableValues; track option.annualAssessmentTaxableValueId) {
                                                            <option [ngValue]="option.annualAssessmentTaxableValueId">
                                                                {{ option.label }}
                                                            </option>
                                                        }
                                                    </select>
                                                } @else {
                                                    {{ taxableValueLabel(taxAuthority.annualAssessmentTaxableValueId) }}
                                                }
                                            } @else {
                                                {{ taxableAssessmentTypeName(taxAuthority.displayTaxableAssessmentTypeId) }}
                                            }
                                        </td>
                                        <td class="right-align">
                                            @if (!isManualTaxableValueMode) {
                                                {{ taxAuthority.assessedValue | number:"1.0-0" }}
                                            }
                                        </td>
                                        <td class="right-align" [style.padding-right.px]="showToolTip(taxAuthority) ? 0 : 28">
                                            @if (!isManualTaxableValueMode) {
                                                <span class="text-nowrap"
                                                      helpTooltip
                                                      position="top"
                                                      [hasIcon]="true"
                                                      [helpDisabled]="!showToolTip(taxAuthority)"
                                                      [contentComponent]="getAdjustmentContentComponent(taxAuthority)">
                                                    {{ taxAuthority.assessedValueAdjustment | number:"1.0-0" }}
                                                </span>
                                            }
                                        </td>
                                        <td class="right-align">{{ taxAuthority.taxableAssessedValue | number:"1.0-0" }}</td>
                                        <td [class]="'right-align ' + rateClass(taxAuthority)"
                                            [tooltip]="taTooltip(taxAuthority)"
                                            container="body">
                                            {{ taxAuthority.rate * 100 | number:"1.6-6" }}
                                        </td>
                                        <td [class]="'processing-action ' + rateClass(taxAuthority)"
                                            (click)="startFirstEncounter(taxAuthority)"
                                            [tooltip]="showFirstEncounter(taxAuthority) ? 'Process tax authority first encounter' : taTooltip(taxAuthority)"
                                            container="body">
                                            @if (showFirstEncounter(taxAuthority)) {
                                                <i class="fa fa-edit ms-2 clickable"
                                                ></i>
                                            }
                                        </td>
                                        <td [class]="'right-align ' + rateClass(taxAuthority)"
                                            [tooltip]="taTooltip(taxAuthority)"
                                            container="body">
                                            {{ taxAuthority.annualTaxAmount | number:"1.2-2" }}
                                        </td>
                                        <td class="right-align">
                                            @if (!readOnly && !model.taxRateAreaId && !model.usingParentRates && !isEarlierRevisionSelected) {
                                                <button
                                                    [disabled]="loading"
                                                    type="button"
                                                    class="edit-control btn-sm ace-btn has-icon btn-primary btn-danger remove-authority"
                                                    (click)="removeTaxAuthority(taxAuthority)">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            }
                                        </td>
                                    </tr>
                                }
                            }
                            <tr class="summary-row no-hover">
                                <td colspan="5">
                                    @if (!readOnly && model && !model.usingParentRates && !model.taxRateAreaId && !isEarlierRevisionSelected && filteredAvailableTaxAuthorities.length > 0) {
                                        <select
                                            [ngModel]="newTaxAuthorityId"
                                            (ngModelChange)="onNewTaxAuthorityChange($event)"
                                            [disabled]="loading"
                                            class="form-select form-select-sm new-tax-auth">
                                            <option value="">Add new tax authority</option>
                                            @for (
                                                availableTaxAuthority of filteredAvailableTaxAuthorities; track availableTaxAuthority) {
                                                <option
                                                    [value]="availableTaxAuthority.taxAuthorityId">
                                                    {{ availableTaxAuthority.name }}
                                                </option>
                                            }
                                        </select>
                                    }
                                    @if (model && !model.taxRateAreaId && filteredAvailableTaxAuthorities.length <= 0) {
                                        <span>
                                            (no more available tax authorities to add)
                                        </span>
                                    }
                                </td>
                                @if (model && model.taxAuthorities && model.taxAuthorities.length > 0) {
                                    <td colspan="2" class="total-label">Total Ad Valorem:</td>
                                    <td [class]="'total-rate' + (totalEstimated ? ' estimated' : '')">{{ model.totalTaxRate * 100 | number:"1.6-6" }}</td>
                                    <td [class]="'total-rate processing-action' + (totalEstimated ? ' estimated' : '')"></td>
                                    <td [class]="'total-rate' + (totalEstimated ? ' estimated' : '')">
                                        {{ model.totalTaxAmount | number:"1.2-2" }}
                                    </td>
                                    <td></td>
                                }
                                @if (!(model && model.taxAuthorities && model.taxAuthorities.length > 0)) {
                                    <td colspan="6"></td>
                                }
                            </tr>
                            @if (model && model.taxAuthorities && model.taxAuthorities.length > 0) {
                                <tr class="summary-row no-hover">
                                    <td colspan="5"></td>
                                    <td colspan="2" class="total-label">Direct Asmt:</td>
                                    <td colspan="2"></td>
                                    <td [class]="'right-align' + (billEstimated ? ' estimated' : '')"
                                        style="border-bottom:1px solid black">
                                        {{ model.directAssessmentTaxAmount | number:"1.2-2" }}
                                    </td>
                                    <td></td>
                                </tr>
                                <tr class="summary-spacer no-hover">
                                    <td colspan="9"></td>
                                    <td [class]="totalEstimated ? ' estimated' : ''"></td>
                                    <td></td>
                                </tr>
                                <tr class="summary-row no-hover">
                                    <td colspan="5"></td>
                                    <td colspan="2" class="total-label">System Calculated Tax:</td>
                                    <td colspan="2"></td>
                                    <td [class]="'right-align' + (totalEstimated ? ' estimated' : '')">
                                        {{ model.calculatedTaxAmount | number:"1.2-2" }}
                                    </td>
                                    <td></td>
                                </tr>
                                <tr class="summary-row no-hover">
                                    <td colspan="5"></td>
                                    <td colspan="2" class="total-label">Total Bill Amount(s):</td>
                                    <td colspan="2"></td>
                                    <td [class]="'right-align' + (billEstimated ? ' estimated' : '')">
                                        {{ model.totalBillTaxAmount | number:"1.2-2" }}
                                    </td>
                                    <td></td>
                                </tr>
                                <tr class="summary-row no-hover">
                                    <td colspan="5">
                                    <td colspan="2" class="total-label">Variance:</td>
                                    <td colspan="2"></td>
                                    <td class="right-align">{{ model.taxAmountVariance | number:"1.2-2" }}</td>
                                    <td></td>
                                </tr>
                                @if (model.otherBillTaxAmount) {
                                    <tr class="summary-row no-hover"
                                        style="height:1em;"
                                    >
                                        <td colspan="11">
                                    </tr>
                                }
                                @if (model.otherBillTaxAmount) {
                                    <tr class="summary-row no-hover">
                                        <td colspan="11" class="right-align">
                                            Note that {{ model.otherBillTaxAmount | number:"1.2-2" }} of the bill
                                            amount is from
                                            tax bills not displayed here
                                        </td>
                                    </tr>
                                }
                            }
                        </table>
                    </div>
                    <hr/>
                </div>
            }
        </div>
    }
    @if (!firstEncounterTaxAuthority) {
        <div class="modal-footer tax-rate-setup">
            @if (!loadingAll && model) {
                <div class="group-by-category">
                    <label>
                        <input type="checkbox" [ngModel]="groupByCategory"
                               (ngModelChange)="onGroupByCategoryChanged($event)"/>
                        Group by Category
                    </label>
                    <br/>
                    <label style="margin-bottom:0">
                        <input type="checkbox"
                               [(ngModel)]="model.usingParentRates"
                               (ngModelChange)="onUsingParentRatesChanged($event)"
                               [disabled]="readOnly || isEarlierRevisionSelected"/>
                        Sync to parcel's collector defaults
                    </label>
                </div>
            }
            @if (!readOnly) {
                <div class="action-buttons">
                    @if (!isDocumentProcessing) {
                        <button class="ace-btn btn-primary"
                                [disabled]="loading || loadingAll"
                                (click)="save()">Save
                        </button>
                    }
                    @if (isDocumentProcessing) {
                        <button class="ace-btn btn-primary"
                                [disabled]="loading || loadingAll"
                                (click)="save()">OK
                        </button>
                    }
                    <button class="ace-btn btn-secondary" (click)="closeModal()">Cancel</button>
                </div>
            }
            @if (readOnly) {
                <div class="action-buttons">
                    <button class="ace-btn btn-secondary" (click)="closeModal()">Done</button>
                </div>
            }
        </div>
    }
</ws-modal-wrapper>
@if (firstEncounterTaxAuthority) {
    <first-encounter
        [taxAuthority]="firstEncounterTaxAuthority"
        [intakeAttachmentId]="intakeAttachmentId"
        [hasProcessingChanges]="calcProjected && hasProcessingChanges"
        [billId]="processingBill.billID"
        (hidden)="endFirstEncounter(false)"
        (saved)="endFirstEncounter(true, $event)"
    ></first-encounter>
}
